import React from "react";
import { Box, FormControlLabel, Radio, Typography } from "@mui/material";

const BRAND = "#78374a";

export default function RadioOptionCard({
  value,
  title,
  description,
  selected = false,
  disabled = false,
  sx,
}) {
  return (
    <Box
      sx={{
        mb: 1.5,
        borderRadius: "6px",
        border: `2px solid ${selected ? BRAND : "#E0E0E0"}`,
        backgroundColor: selected ? "rgba(120, 55, 74, 0.06)" : "#fff",
        opacity: disabled ? 0.55 : 1,
        transition: "border-color 0.15s ease, background-color 0.15s ease",
        "&:hover": disabled
          ? undefined
          : {
              borderColor: selected ? BRAND : "#BBB",
              backgroundColor: selected ? "rgba(120, 55, 74, 0.08)" : "#FAFAFA",
            },
        ...sx,
      }}
    >
      <FormControlLabel
        value={value}
        disabled={disabled}
        control={<Radio color="primary" sx={{ pt: 1.5, alignSelf: "flex-start" }} />}
        sx={{
          alignItems: "flex-start",
          m: 0,
          width: "100%",
          px: 1.5,
          py: 1.25,
          cursor: disabled ? "default" : "pointer",
        }}
        label={
          <Box sx={{ pt: 0.75, pr: 0.5 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: selected && !disabled ? BRAND : "inherit",
                lineHeight: 1.3,
              }}
            >
              {title}
            </Typography>
            {description && (
              <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                {description}
              </Typography>
            )}
          </Box>
        }
      />
    </Box>
  );
}
